import {CommonModule} from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Dropdown} from 'bootstrap';
import {debounceTime, distinctUntilChanged, fromEvent, Subscription,} from 'rxjs';
import {CheckboxModule} from '@app/checkbox/checkbox.module';
import {SwitchComponent} from "@app/switch/switch.component";
import {StateSwitchCustomComponent} from "@app/state-switch-custom/state-switch-custom.component";

@Component({
  selector: 'app-dropdown-double',
  templateUrl: './dropdown-double.component.html',
  styleUrls: ['./dropdown-double.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, CheckboxModule, SwitchComponent, StateSwitchCustomComponent],
})
export class DropdownDoubleComponent implements AfterViewInit, OnChanges, OnInit, OnDestroy {
  @Input() multipleSelect?: boolean = false;
  @Input() placeholder?: string = '';
  @Input() isError: boolean = false;
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Output() itemSelected = new EventEmitter<string>();
  @ViewChild('searchInput', {static: true}) searchInput!: ElementRef;
  @ViewChild('dropdown', {static: true}) dropdownRef!: ElementRef;
  protected dropdownButtonDefaultText: string = '';
  protected dropdownButtonText: string = '';
  protected searchText: string = '';
  protected checkedList: { [key: string]: boolean } = {};
  protected allChecked: boolean = false;
  protected checkedCounter: number = 0;
  private searchSubscription!: Subscription;
  private dropdown!: Dropdown;
  private defaultItems: string[] = [];
  
  listID: 1 | 2 = 1;
  items: string[] = [];
  
  _items1: string[] = [];
  @Input()
  set items1(value: string[]) {
    this._items1 = value;
    
    if(this.listID === 2) {
      this.defaultItems = value;
      this.checkedList = {};
      this.reset()
    }
    
    
  }
  get items1() {
    return this._items1;
  }
  
  _items2: string[] = [];
  @Input()
  set items2(value: string[]) {
    this._items2 = value;
    
    if(this.listID === 1) {
      this.defaultItems = value;
      this.checkedList = {};
      this.reset()
    }
  }
  get items2() {
    return this._items2;
  }

  @Input() set defaultSelectedValues(values: string[]) {
    const defaultChecked = values?.reduce((acc: { [key: string]: boolean }, curr) => {
      acc[curr] = true;
      return acc;
    }, {}) || {};

    // must be async to let other inputs settle
    setTimeout(() => this.onCheckedChange(defaultChecked))
  } ;

  ngOnInit() {
    this.dropdownButtonDefaultText = this.placeholder || '';
  }

  ngAfterViewInit() {
    this.searchSubscription = fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(
        debounceTime(500), // Adjust the debounce time as needed
        distinctUntilChanged()
      )
      .subscribe((event) => this.onSearchInputChange(event as Event));

    this.dropdown = new Dropdown(this.dropdownRef.nativeElement, {
      popperConfig: {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 4],
              autoClose: 'outside',
            },
          },
        ],
      },
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.checkedList = {};
    // if (changes['items'] && changes['items'].currentValue) {
    //   this.defaultItems = changes['items'].currentValue;
    // }
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  onCheckAll(): void {
    this.allChecked = !this.allChecked;
    const checkedUpdate: { [key: string]: boolean } = this.items.reduce(
      (acc: { [key: string]: boolean }, item) => {
        acc[item] = this.allChecked;
        return acc;
      },
      {}
    );
    this.onCheckedChange(checkedUpdate);
  }

  onCheckedChange(checkedUpdate: { [key: string]: boolean }): void {
    this.isError = false;
    this.checkedList = {...this.checkedList, ...checkedUpdate};

    const checkedItems = Object.values(this.checkedList).filter(
      (option) => option
    );
    this.allChecked = checkedItems.length === this.items.length;
    this.checkedCounter = checkedItems.length - 1;

    this.dropdownButtonText =
      Object.keys(this.checkedList).filter((key) => this.checkedList[key])[0] ||
      '';
    this.itemSelected.emit(
      Object.keys(this.checkedList)
        .filter((key) => this.checkedList[key])
        .join('&')
    );

  }

  dropdownOpen(event: MouseEvent): void {
    if (this.disabled) {
      return;
    }
    event.stopPropagation();
    this.searchText = '';
    this.items = this.defaultItems;
    const dropdownElement = this.dropdownRef.nativeElement;
    if (dropdownElement.classList.contains('show')) {
      this.dropdown.hide();
    } else {
      document.querySelectorAll('.dropdown-toggle.show')?.forEach(() => {
        document.querySelector('body')?.click();
      });
      this.dropdown.show();
    }
  }

  onSearchInputChange(event: Event): void {
    if (!this.searchText) {
      this.items = this.defaultItems;
      return;
    }
    this.items = this.defaultItems.filter((item) =>
      item.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onItemSelected(item: string): void {
    this.isError = false;
    this.dropdownButtonText = item;
    this.itemSelected.emit(item);
  }
  
  onSwitchChange(data: {state: 1 | 2 }) {
    this.listID = data.state === 1 ? 1 : 2;
    if (this.listID === 2) {
      this.items = this.items1;
      this.defaultItems = this.items1;
    } else {
      this.items = this.items2;
      this.defaultItems = this.items2;
    }
    this.reset()
  }
  
  reset() {
    this.checkedList = {};
    this.allChecked = false;
    this.checkedCounter = 0;
    this.dropdownButtonText = '';
    this.searchText = '';
    this.itemSelected.emit('');
  }
}
